import { Component, OnInit } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { DataTableFilterMessageService } from '../../../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { PropertiesFilterStateService } from '../../../services/properties-filter-state.service';
import { PropertiesMessageService } from '../../../services/properties-table-message.service';
import { BaseDataTableFilter } from '../../../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';

@Component({
  selector: 'app-properties-filter-status',
  templateUrl: './properties-filter-status.component.html',
  styleUrls: ['./properties-filter-status.component.scss'],
  standalone: true,
  imports: [
    MatRadioModule,
    FormsModule
  ]
})
export class PropertiesFilterStatusComponent extends BaseDataTableFilter implements OnInit {

  constructor(
    private filterStateService: PropertiesFilterStateService,
    private filterMessageService: DataTableFilterMessageService,
    private propertiesMessageService: PropertiesMessageService
  ) {
    super(filterMessageService);
  }

  ngOnInit(): void {
    if (this.filterStateService.status != 0) {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
  }

  onApplyClicked(): void {
    const isActive = this.filterStateService.status != 0;
    this.filterMessageService.setActive({ filterId: this.id, active: isActive, value: this.getFilterStatusText() });
    this.propertiesMessageService.applyFilter();
  }

  onClearClicked(): void {
    this.filterStateService.resetStatusFilter();
    this.propertiesMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: false });
  }

  getStateService(): PropertiesFilterStateService {
    return this.filterStateService;
  }

  openedChange(opened: boolean) {
    const clickoutEnabled = !opened;
    this.filterMessageService.setClickoutEnabled(clickoutEnabled);
  }

  private getFilterStatusText(): string {
    let statusText = '';
    if (this.filterStateService.status == 1) {
      statusText = "ACTIVE";
    }
    if (this.filterStateService.status == 2) {
      statusText = "INACTIVE";
    }

    return statusText;
  }
}